import callAPiBase from './base';

const garageApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/garageList',
      method: 'GET',
      useToken: true,
      title: 'Garage - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/garageCreate',
      method: 'POST',
      useToken: true,
      title: 'Garage - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/garageUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Garage - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/garageDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Garage - Delete',
      params,
    }),
};

export { garageApi };
export default garageApi;
